var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import PolicyCard from './PolicyCard';
import Building from '../../../../icons/BusinessType/Building';
import Sheild from '../../../../icons/BusinessType/Sheild';
import Lock from '../../../../icons/BusinessType/Lock';
import Tools from '../../../../icons/BusinessType/Tools';
import PolicyStepsHeader from '../../../../../components/common/PolicyStepsHeader';
import PolicyFormProgressBar from '../../../../common/PolicyFormProgressBar';
import useWidgetStore, { CurrentTabEnum, } from '../../../../../stores/widgetStore';
import useCustomerStore from '../../../../../stores/customerStore';
import useProductStore from '../../../../../stores/productStore';
import useSaasPlatformStore from '../../../../../stores/saasPlatformStore';
import useLatestQuotesWithPolicies from '../../../../../hooks/useLatestQuotesWithPolicies';
var RecommendedPolicies = function () {
    var _a = useWidgetStore(), selectedBusinessTypeOptions = _a.selectedBusinessTypeOptions, setCurrentTab = _a.setCurrentTab, setModalOpen = _a.setModalOpen, setSelectedQuote = _a.setSelectedQuote, setRecommendedPolicies = _a.setRecommendedPolicies, setApplicationDataId = _a.setApplicationDataId, setFormActive = _a.setFormActive, setAnswers = _a.setAnswers, recommendedPolicies = _a.recommendedPolicies, eligibilityEngineAnswers = _a.eligibilityEngineAnswers;
    var _b = useCustomerStore(), applicationFormData = _b.applicationFormData, eligibilityEngine = _b.eligibilityEngine;
    var setProduct = useProductStore().setProduct;
    var Products = useSaasPlatformStore().Products;
    var latestQuotes = useLatestQuotesWithPolicies(true);
    var recommendationEngine = function () {
        var recommendations = new Set();
        if (selectedBusinessTypeOptions.includes('service')) {
            recommendations.add('PL');
        }
        if (selectedBusinessTypeOptions.includes('data')) {
            recommendations.add('Cyber');
        }
        var recommendsBOP = selectedBusinessTypeOptions.includes('building') ||
            selectedBusinessTypeOptions.includes('equipment');
        if (recommendsBOP) {
            recommendations.add('BOP');
        }
        else {
            recommendations.add('GL');
        }
        return Array.from(recommendations);
    };
    useEffect(function () {
        var intialRecommendedPolicies = recommendationEngine();
        setRecommendedPolicies(intialRecommendedPolicies);
    }, []);
    var handleSelection = function (id) {
        var _a;
        var product = (_a = Products === null || Products === void 0 ? void 0 : Products.find) === null || _a === void 0 ? void 0 : _a.call(Products, function (p) { return p.id == applicationFormData[id].productId; });
        setApplicationDataId(id);
        setAnswers(applicationFormData[id].applicationDetails);
        setProduct(product);
        setFormActive(true);
        setCurrentTab(CurrentTabEnum.POLICY);
        setSelectedQuote(null);
    };
    var handleClose = function () {
        setCurrentTab(CurrentTabEnum.POLICY);
        setSelectedQuote(null);
        setModalOpen(false);
    };
    var handleBack = function () {
        setCurrentTab(eligibilityEngine
            ? CurrentTabEnum.ELIGIBILITY_ENGINE
            : CurrentTabEnum.BUSINESS_TYPE_SELECTION);
    };
    var handleNext = function () {
        var _a;
        var firstRecommendedPolicy = (eligibilityEngine
            ? eligibilityEngineAnswers === null || eligibilityEngineAnswers === void 0 ? void 0 : eligibilityEngineAnswers.availableProducts[0]
            : recommendedPolicies[0]) || 'GL';
        setApplicationDataId(firstRecommendedPolicy);
        setAnswers(applicationFormData[firstRecommendedPolicy].applicationDetails);
        setProduct((_a = Products === null || Products === void 0 ? void 0 : Products.find) === null || _a === void 0 ? void 0 : _a.call(Products, function (p) { return p.id == applicationFormData[firstRecommendedPolicy].productId; }));
        setFormActive(true);
        setCurrentTab(CurrentTabEnum.POLICY);
    };
    var policyOptions = {
        GL: {
            id: 'GL',
            icon: React.createElement(Sheild, null),
            heading: 'General Liability Insurance',
            subheading: 'Basic Protection for all businesses',
            description: 'Provides coverage for claims by others of property damage, bodily injury, and personal injury (slander and libel).',
            condition: 'Cannot be purchased with Business Owners Policy'
        },
        BOP: {
            id: 'BOP',
            icon: React.createElement(Building, { size: "32" }),
            heading: 'Business Owners Policy',
            subheading: 'General Liability plus your business property',
            description: 'Includes General Liability coverage plus protection against damage to your personal business property and/or buildings, and loss of business income due to property damage.',
            condition: 'Cannot be purchased with General Liability'
        },
        Cyber: {
            id: 'Cyber',
            icon: React.createElement(Lock, null),
            heading: 'Cyber',
            subheading: 'Protection for your data',
            description: 'Get access to a panel of breach response experts who will help you respond to a cyber event, minimize the damage, and get your business back up and running.'
        },
        PL: {
            id: 'PL',
            icon: React.createElement(Tools, null),
            heading: 'Professional Liability',
            subheading: 'Protection against claims of errors, omissions or negligence that lead to financial harm for clients.',
            description: 'insurance designed to cover compensation and legal defence costs. If a member of the public claims they have been injured because of your work, PL can help. The same applies if they claim you have damaged their property while working.'
        }
    };
    var handleDisableButtonState = function (currentPolicy) {
        if (eligibilityEngine) {
            return !(eligibilityEngineAnswers === null || eligibilityEngineAnswers === void 0 ? void 0 : eligibilityEngineAnswers.availableProducts.includes(currentPolicy));
        }
        else {
            var isThisRecommendedCard = recommendedPolicies.includes(currentPolicy);
            if (!isThisRecommendedCard) {
                if (currentPolicy === 'GL')
                    return true;
                else if (currentPolicy === 'BOP') {
                    return true;
                }
            }
            return false;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "decline-popup-container" }),
        React.createElement("div", { className: "flex flex-col min-h-full items-center" },
            React.createElement(PolicyStepsHeader, { steps: [
                    {
                        stepText: 'Coverage',
                        isStepActive: true,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Business Info',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Review',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Purchase',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                ], backButtonText: "Back", handleBack: handleBack, handleNext: handleNext, nextButtonText: "Continue", handleClose: handleClose, hideNextButton: true }),
            (!latestQuotes || latestQuotes.length === 0) && (React.createElement("div", { className: "w-full pt-6 pb-10 px-6" },
                React.createElement(PolicyFormProgressBar, { steps: 2, activeStep: 2 }))),
            React.createElement("div", { className: "flex-1 w-full overflow-y-auto" },
                React.createElement("div", { className: "flex flex-col gap-5 md:gap-6 px-3 md:px-4 py-3 flex-grow max-w-[1300px] mx-auto" },
                    React.createElement("div", null,
                        React.createElement("h2", { className: "text-2xl md:text-3xl font-bold mb-2 leading-snug" }, "We've suggested the best coverages for your business below."),
                        React.createElement("p", { className: "text-[#252846] font-normal text-sm md:text-base" }, "You're still able to adjust selections to meet your needs.")),
                    React.createElement("div", { className: "text-left p-3 md:p-4 bg-[#F8FAFE] rounded-xl" },
                        React.createElement("h3", { className: "text-xl md:text-2xl font-bold" }, "Essential Business Protection"),
                        React.createElement("p", { className: "text-[#252846] font-normal text-xs md:text-sm" }, "Select one of these two that best suits your needs:")),
                    React.createElement(PolicyCard, __assign({}, policyOptions['GL'], { selected: !eligibilityEngine && recommendedPolicies.includes('GL'), onClick: function () { return handleSelection('GL'); }, disabled: handleDisableButtonState('GL'), coverageType: "GL" })),
                    React.createElement("div", { className: "relative flex items-center justify-center my-2" },
                        React.createElement("div", { className: "absolute w-full border-t border-gray-300" }),
                        React.createElement("span", { className: "bg-white px-2 text-gray-500 z-10" }, "OR")),
                    React.createElement(PolicyCard, __assign({}, policyOptions['BOP'], { selected: !eligibilityEngine && recommendedPolicies.includes('BOP'), onClick: function () { return handleSelection('BOP'); }, disabled: handleDisableButtonState('BOP'), coverageType: "BOP" })),
                    React.createElement("div", { className: "text-left p-3 md:p-4 bg-[#F8FAFE] rounded-xl mt-4 md:mt-5" },
                        React.createElement("h3", { className: "text-xl md:text-2xl font-bold" }, "Protection from cyber-related security risks")),
                    React.createElement("div", null,
                        React.createElement(PolicyCard, __assign({}, policyOptions['Cyber'], { selected: !eligibilityEngine && recommendedPolicies.includes('Cyber'), onClick: function () { return handleSelection('Cyber'); }, disabled: eligibilityEngine && handleDisableButtonState('Cyber'), coverageType: "Cyber" }))),
                    React.createElement("div", { className: "text-left p-3 md:p-4 bg-[#F8FAFE] rounded-xl mt-4 md:mt-5" },
                        React.createElement("h3", { className: "text-xl md:text-2xl font-bold" }, "Protection for businesses that provide professional advice or services")),
                    React.createElement("div", { className: "mb-3" },
                        React.createElement(PolicyCard, __assign({}, policyOptions['PL'], { selected: !eligibilityEngine && recommendedPolicies.includes('PL'), onClick: function () { return handleSelection('PL'); }, disabled: eligibilityEngine && handleDisableButtonState('PL'), coverageType: "PL" }))),
                    React.createElement("div", null,
                        React.createElement("p", { className: "text-left text-sm md:text-base" }, "For questions, please call 1-888-873-1082. Business hours are Monday to Friday 9:00am to 6:00pm Eastern Time, excluding statutory holidays.")))))));
};
export default RecommendedPolicies;
// bb824ff3d9f0
